import { render, staticRenderFns } from "./BackOfficeActionReason.vue?vue&type=template&id=e2477502&"
import script from "./BackOfficeActionReason.vue?vue&type=script&lang=ts&"
export * from "./BackOfficeActionReason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports